export const EMAIL = 'volockove@gmail.com';
